import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { apiGestao } from 'services/api/api';

const useFaqPdfLink = async (): Promise<string> => {
  const { usuario } = useSelector((state: RootState) => state.token);

  const faqPdfLink = useQuery({
    queryKey: ['pdfLink'],
    queryFn: async ({ signal }) => {
      const response = await apiGestao.get('/dominios/link-pdf-faq', {
        signal,
      });
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    enabled: usuario !== undefined,
    retry: false,
  });
  if (!faqPdfLink.data) {
    console.error('Link para download da FAQ não encontrado.');
    return '';
  }
  return faqPdfLink.data;
};

export default useFaqPdfLink;
